export default __webpack_public_path__ + "static/media/site-2-264-800kbps.293cf5b2.mp4";